import { merge } from 'ramda'

import { combineReducers, createReducer } from 'utils/redux'

import * as actions from './actions'

const namespace = createReducer(
  {},
  {
    [actions.receiveCutoverNamespace.toString()]: ({ draft, action }) => {
      return merge(draft, action.payload)
    },
  }
)

export default combineReducers({
  namespace,
})
